/**
 * Canonical Brand Kit route.
 *
 * Every tenant uses the same editor. Branding is the sole visual-identity
 * authoring surface; customer journeys and pages only consume its published
 * theme. Unsupported capabilities stay visible as disabled “Coming soon”
 * controls so the screen never promises a write that the service cannot store.
 */
import BrandingDesigner from "./branding-designer";
import { useBrandKit } from "./branding-kit";

export default function SettingsBranding() {
  return <BrandingDesigner kit={useBrandKit()} />;
}
